import React from "react";

import Project from "./project";

import INFO from "../../data/user";
import { getProjectPath } from "../../data/projectUtils";

import "./styles/allProjects.css";

const AllProjects = () => {
	return (
		<div className="all-projects-container">
			{INFO.projects.map((project, index) => (
				<div className="all-projects-project" key={index}>
					<Project
						logo={project.logo}
						title={project.title}
						description={project.description}
						outcome={project.outcome}
						stack={project.stack}
						github={project.github}
						live={project.live}
						path={getProjectPath(project)}
					/>
				</div>
			))}
		</div>
	);
};

export default AllProjects;
